import type { CardThumbnailProvider } from "../Card";

type ProviderType = {
  name?: string | null;
  handle?: string | null;
};

type ProviderGame = {
  menuItem?: Array<ProviderType | null | undefined> | null;
};

const computeProvider = (game: ProviderGame): CardThumbnailProvider | null => {
  if (!game) return null;
  const provider = game.menuItem?.[0];
  if (!provider?.handle) return null;
  return { name: provider.name ?? " " };
};

export default computeProvider;
